import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HomePage } from '../home/home';
import { GlobalProvider } from '../../providers/global/global';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@IonicPage()
@Component({
  selector: 'page-client',
  templateUrl: 'client.html',
})
export class ClientPage {

  data: Observable<any>;
  url_client: any[];
  banco: string;
  pag: string;
  client_title: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public global: GlobalProvider, public http: HttpClient) {

  }

  ionViewDidLoad() {
    this.show_client();
  }

  show_client()
  {
    this.global.urls = [];
    this.global.check_jwt();
    try {
      if (this.global.permissions.length > 1) {
        this.client_title = "Selecione o ambiente:";
        this.global.changeClient_enable = true;
        for (let n = 0; n < this.global.permissions.length; n++) {
          try {
            var url = 'http://iot.digicomp.com.br/api/public/ping/logo_url';
            let body = new FormData();
            body.append('db', this.global.permissions[n]);
            body.append('jwt', this.global.token);
            this.data = this.http.post(url, body);
            this.data.subscribe(data => {
              this.global.urls[n] = data.complemento;
            });
          }
          catch (e) {
            console.error(e);
          }
        }
      }
      else {
        this.global.changeClient_enable = false;
        this.select_client(this.global.permissions[0])
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  select_client(url_logo) {
    this.global.check_jwt();
    if (this.global.permissions.length > 1) {
      this.global.banco = url_logo.split('_')[1];
    }
    else {
      this.global.banco = url_logo;
    }
    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/nome_menu';
      let body = new FormData();
      body.append('db', this.global.banco);
      body.append('jwt', this.global.token);
      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        this.global.nome_menu = [];
        for (let i = 0; i < data.length; i++) {
          this.global.nome_menu[i] = data[i].nome_menu;
        }
        this.global.menu = this.global.nome_menu[0];
        this.navCtrl.setRoot(HomePage);
      });
    }
    catch (e) {
      console.error(e);
    }
  }

  getItems(ev) {
    if (ev.data == null)
    {
      this.show_client();
    }
    var val = ev.target.value;
    if (val && val.trim() != '') {
      this.global.urls = this.global.urls.filter((url) => {
        return (url.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/client/client.ts